function getAjaxBase() {
    const segments = window.location.pathname.split('/').filter(Boolean);
    return segments[0] === 'en' ? '/en' : '';
}

export default function initClubDiscount() {
    if (document.body.classList.contains('logged-in')) return;

    const discountEl = document.querySelector('.club-discount');
    if (!discountEl) return;

    const em = discountEl.querySelector('em');
    if (!em) return;

    const br = discountEl.querySelector('br');

    fetch(getAjaxBase() + '/?wc-ajax=cbdonna_club_discount', { method: 'POST' })
        .then((r) => r.json())
        .then((data) => {
            if (!data || !data.success) return;

            const { discount, discount_formatted } = data.data;

            if (discount > 0 && discount_formatted) {
                if (em.innerHTML.includes('%discount%')) {
                    em.innerHTML = em.innerHTML.replace('%discount%', discount_formatted);
                }
                if (br) br.style.display = 'block';
                em.style.display = 'inline';
            }
        })
        .catch(() => {});
}
